import 'Vendor/owlcarousel/owl.carousel.min';
import { speed } from 'Lib/speed/speed';
import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';

const $author = $('.authors-new-block');
const cSliderOn = 'owl-carousel';

if (getW() > eksmoBP.mdMin) {
    $author.trigger('destroy.owl.carousel')
        .removeClass(cSliderOn)
        .addClass(cSliderOn)
        .owlCarousel({
            smartSpeed: speed,
            dots: false,
            nav: true,
            margin: 40,
            items: 4,
            slideBy: 4,
            responsive: {
                1300: {
                    items: 5,
                    slideBy: 5,
                    nav: true,
                },
            },
            navClass: [
                `authors-new-block__arrow-prev arrow arrow_prev arrow_shadow`,
                `authors-new-block__arrow-next arrow arrow_next arrow_shadow`,
            ],
            navText: ['', ''],
            mouseDrag: true,
        });
}